import { useMemo, useState } from "react";
import { Flex } from "antd";
import { Dropdown, radius } from "@libertify/ui";
import { ItemCardPreview } from "../../storyboardEditor/components/controls/ItemCardPreview";
import { EditButton } from "../../storyboardEditor/components/controls/EditButton";
import { ImageVideoPreview } from "../../storyboardEditor/components/common/ImageVideoPreview";
import { ITEM_TYPES } from "../../storyboardEditor/types";
import { useThemeData } from "../hooks/useThemeData";
import { PresenterProfileResponse } from "pages/media/types";

const getPresenterAssetPath = (presenter: PresenterProfileResponse) =>
  presenter.face_profile?.thumbnail_asset_path ??
  presenter.face_profile?.extracted_asset_path ??
  presenter.face_profile?.custom_asset_path ??
  undefined;

export const PresenterSelector = () => {
  const { presenters, activePresenter, setPresenter } = useThemeData();
  const [open, setOpen] = useState(false);

  const presentersWithFace = useMemo(
    () => presenters.filter((p) => !!p.face_profile),
    [presenters]
  );

  const dropdownItems = useMemo(
    () =>
      presentersWithFace.map((presenter) => ({
        key: presenter.id,
        label: (
          <Flex align="center" gap={8} style={{ padding: "4px 0" }}>
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: radius.box,
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <ImageVideoPreview
                type={ITEM_TYPES.Image}
                path={getPresenterAssetPath(presenter)}
                assetId={
                  presenter.face_profile?.thumbnail_asset_id ?? undefined
                }
                style={{ objectFit: "cover", width: 60, height: 60 }}
              />
            </div>
            <span>{presenter.name}</span>
          </Flex>
        ),
        onClick: () => {
          setPresenter(presenter);
          setOpen(false);
        },
      })),
    [presentersWithFace, setPresenter]
  );

  if (!activePresenter) return null;

  return (
    <Dropdown
      items={dropdownItems}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      overlayStyle={{ maxWidth: "275px" }}
    >
      <ItemCardPreview
        item="presenter"
        cover={{
          path: getPresenterAssetPath(activePresenter),
          assetId:
            activePresenter.face_profile?.thumbnail_asset_id ?? undefined,
        }}
        title={activePresenter.name}
        editButton={<EditButton item="avatar" onClick={() => setOpen(true)} />}
      />
    </Dropdown>
  );
};
